module.exports = __webpack_public_path__ + "static/home-banner-2-8b2d100fca1d6aa67b17708acb5e1476.jpg";